/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";


import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { formatViews, handleDiscountedPrice } from "../../utils/course";

// third-party
import FsLightbox from "fslightbox-react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { IoCopyOutline, IoShareSocialOutline } from "react-icons/io5";
import ToolTip from "../../common/Tooltip/ToolTip";
import EbookStarRating from "./EbookStarRating";
import { showToast } from "../sweet-alert/Sweetalert";
import GenericPdfViewer from "../../pages/blogMedia/GenericPdfViewerTwo";
import { useUserContext } from "../../context/user_context";
import moment from "moment";
import { useOrderContext } from "../../context/order_context";
import ModalLogin from "../form/ModalLogin";
import { PaymentSuccessModel } from "../success-model/PaymentSuccessModel";
import { TestimonialForm } from "../form/TestimonialForm";
import Image from "../../common/footer/Images/Image";
import { FREE, PAID } from "../../constants";
import Spinner from "../spinner-component/SpinnerOne";

// Reading env variable
const VENDOR_NAME = process.env.REACT_APP_RAZOR_APP_VENDOR_NAME;
const RAZOR_THEME = process.env.REACT_APP_RAZOR_APP_THEME_COLOR;

const EBookInfo = ({ data, activeStatus }) => {

    // reading context variables and methods
    const { loginData } = useUserContext();
    const {
        fetchOrders,
        orderLoading,
        createOrders,
        isPaymentSuccess,
        closePaymentSuccessModal,
        downloadEbook,
        ordersError,
    } = useOrderContext();

    // State variables
    const [toggler, setToggler] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [notLoggedIn, setNotLoggedIn] = useState(false);
    const [newOrder, setNewOrder] = useState({});
    const [showTestimonialModal, setShowTestimonialModal] = useState(false);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);

    const member =
        loginData && loginData?.data && loginData?.data?.userId
            ? loginData?.data
            : [];

    const text = `Check out the '${data?.name}' from the Longswitch Academy`;
    const url = window.location.href;

    const message = encodeURIComponent(`${text} ${url}`);

    const reviews =
        data && data?.metadata && data?.metadata?.ratings && data?.metadata?.ratings !== "0"
            ? data?.metadata?.ratings
            : "[]";

    // this will remove the tralling commas as there is the comma that making error on pars so used this to clean the string
    let cleanString = reviews?.replace(/,\s*([}\]])/g, "$1");
    const review = JSON.parse(cleanString);

    // Get Preview URL
    const previewPath = data && data?.media && data?.media?.previewUrl ? data?.media?.previewUrl : "#";
    const filePath = `${process.env.PUBLIC_URL}/ebook-preview/${previewPath}`
    const previewName = data && data?.name ? data?.name : "Free Preview";

    const isDiscountValid = (data) => {
        try {
            if (
                data &&
                data?.discount &&
                data?.discount?.hasDiscount &&
                handleDiscountedPrice(data)?.isValid
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log(
                "62 : EBookListingOne : Error in isDiscountValid : ",
                error && JSON.stringify(error)
            );
        }
    };

    const eBookAmount =
        data && isDiscountValid(data)
            ? handleDiscountedPrice(data)?.finalAmount * 100
            : data?.pricing?.priceInSmallUnit || 501;
    const eBookDiscount =
        data && isDiscountValid(data)
            ? parseFloat(data?.discount?.discountPercent || "0.00")
            : "0.00";

    const handleDownloadBook = async (data) => {
        if (isProcessingPayment) return;

        try {
            if (!member || (member && !member?.userId)) {
                setNotLoggedIn(true);
                return;
            }

            setIsProcessingPayment(true);

            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DOWNLOAD_BUTTON
            );
            const orderPayload = {
                amount: activeStatus === "free" ? 501 : eBookAmount,
                amountUnit: "paise",
                discount: eBookDiscount,
                orderCurrency: data?.pricing?.priceCurrency || "INR",
                receipt: `${activeStatus}_lsa_portal_order_${Date.now()}`,
                amountPaid: 0.0,
                createdAt: moment(new Date()).format("YYYY-MM-DD"),
                vendorName: VENDOR_NAME,
                customer: {
                    customerId: member?.firebaseUid || member?.userRecordId,
                    email: member?.userId,
                    fullName: member?.userFullName,
                },
                notes: [
                    {
                        id: data?.id,
                        productCode: data?.productCode,
                        name: data?.name,
                        type: data?.type,
                        duration: data?.pricing?.billingCycle,
                        isActive: data?.isActive,
                        category: data?.category,
                        subCategory: data?.subCategory,
                        description: "Purchase Of - " + (data?.name || ""),
                        price: eBookAmount,
                        discountPercent: eBookDiscount,
                        features: data?.features,
                        thumbnailUrl: data?.media?.thumbnailUrl || "#",
                    },
                ],
            };

            if (activeStatus === "free") {
                setNewOrder(orderPayload);
                // calling create order api
                const response = await createOrders(orderPayload);
                if (!ordersError && response !== "error") {
                    downloadEbook({
                        paymentId: response?.razorPayOrderId,
                        productId: data?.productCode,
                        productName: data?.name,
                        entityType: "free",
                    });
                }

                setIsProcessingPayment(false);
                return;
            }
            if (activeStatus === "paid") {
                // calling create order api
                const response = await createOrders(orderPayload);

                if (!ordersError && response !== "error") {
                    const options = {
                        key: process.env.REACT_APP_RAZOR_APP_KEY,
                        order_id: response?.razorPayOrderId,
                        amount: eBookAmount,
                        currency: data?.currency,
                        name: VENDOR_NAME,
                        description: "Purchase Of - " + (data?.name || ""),
                        image: process.env.REACT_APP_LOGO_URL,

                        handler: function (response) {
                            setNewOrder({
                                ...newOrder,
                                ...orderPayload,
                                paymentId: response.razorpay_payment_id,
                            });

                            downloadEbook({
                                paymentId: response?.razorpay_payment_id,
                                productId: data?.productCode,
                                productName: data?.name,
                                entityType: "",
                            });
                            //Open Testimonial Modal
                            // toggleTestimonialModal();
                            // setShowTestimonialModal((prev) => !prev);
                        },
                        // Razorpay modal is now opening
                        modal: {
                            ondismiss: function () {
                                setIsProcessingPayment(false);
                            },
                        },
                        prefill: {
                            name: member?.userFullName,
                            email: member?.userId,
                            contact: "",
                        },
                        theme: {
                            color: RAZOR_THEME,
                        },
                        notify: {
                            sms: true,
                            email: true,
                        },
                        notes: {
                            item_description: "Purchase Of - " + (data?.name || ""),
                            // item_description: data?.description, // You can add item details here as well
                        },
                    };
                    const rzp = new window.Razorpay(options);
                    rzp.open();

                    // API is finished, so remove the loading state
                    setIsProcessingPayment(false);
                } else {
                    setIsProcessingPayment(false);
                }
            }
        } catch (error) {
            console.log(
                "145 : EBookListingOne : Error in handleDownloadBook : ",
                error && JSON.stringify(error)
            );
        }
    };


    const isPaymentDone = () => {
        if (isPaymentSuccess && newOrder && Object.keys(newOrder).length) {
            return true;
        }
    };

    const closeModalLogin = () => setNotLoggedIn(false);

    const closeModalPaymentSuccess = () => {
        try {
            closePaymentSuccessModal();
        } catch (error) { }
    };

    const toggleTestimonialModal = () => {
        try {
            setShowTestimonialModal(!showTestimonialModal);
        } catch (error) {
            console.error(
                "114 : TestimonialForm : Error occurred in toggleTestimonialModal:",
                error && JSON.stringify(error)
            );
            showToast(
                "error",
                "Something went wrong while toggling the testimonial modal. Please try again.",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
        }
    };

    const togglePreviewModal = () => {
        try {
            setToggler(!toggler);
        } catch (error) {
            console.error(
                "179 : EBookTypeOne : Error occurred in togglePreviewModal:",
                error && JSON.stringify(error)
            );
            showToast(
                "error",
                "Something went wrong while toggling the preview modal. Please try again.",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
        }
    }

    // Social media share handlers
    const handleCopyLink = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_COPY_COURSE_LINK);
            navigator.clipboard.writeText(
                url
            );
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 1000);
            showToast(
                "success",
                "Copied E-Book Url successfully!",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
            return;
        } catch (error) {
            console.log("72 : E-BookInfo : Error while sharing on copy link :", error && JSON.stringify(error));
        }
    };

    const handleWhatsAppShare = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SHARE_ON_WHATSAPP);
            window.open(`https://wa.me/?text=${message}`, "_blank");
            setToggler(false);
        } catch (error) {
            console.log("82 : CourseInfo : Error while sharing on whatsapp :", error && JSON.stringify(error));
        }
    };

    const handleTwitterShare = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SHARE_ON_TWITTER);
            window.open(`https://twitter.com/intent/tweet?text=${message}`, "_blank");
            setToggler(false);
        } catch (error) {
            console.log("141 : CourseInfo : Error while sharing on twitter :", error && JSON.stringify(error));
        }
    };

    const handleLinkedInShare = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SHARE_ON_LINKEDIN);
            window.open(
                `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
                "_blank"
            );
            setToggler(false);
        } catch (error) {
            console.log("154 : CourseInfo : Error while sharing on linked in :", error && JSON.stringify(error));
        }
    };

    // TODO: 09242026 - Commented this
    // useEffect(() => {
    //     if (member && member?.userId) {
    //         const userUniqueId = member && ((member?.firebaseUid ? member?.firebaseUid : member?.userRecordId));

    //         fetchOrders(userUniqueId);
    //     }
    // }, [orderLoading, member]);

    return (
        <>
            {isProcessingPayment && <Spinner />}
            <div className="eduvibe-sidebar course-details-sidebar mt-0">
                <div className="inner">
                    <div className="eduvibe-widget">
                        <div className="video-area">
                            <div className="thumbnail">
                                {/*  Orginal code for course image start 16/12/2024 */}

                                {/* <img className="radius-small w-100" src={`${process.env.PUBLIC_URL}/images/course/video-bg/${data.image}`} alt="Course Video Thumb" onError={onImageError} /> */}
                                <div className="thumbnail position-relative">

                                    <Image src={`${process.env.PUBLIC_URL}/images/ebooks/${data?.media?.thumbnailUrl}`} alt={data?.name} className="w-100" fill />

                                    {/* <div className="wishlist-top-right">
                                                       <div className="wishlist-btn"><i className="icon-Heart"></i></div>
                                                   </div> */}

                                    {/* <div className="center-position status-group left-top m-0">
                                    <a href={"#"} onClick={(e) => {
                                        e.preventDefault();
                                        setToggler(prev => !prev);
                                    }} className="underline">
                                        <span className="eduvibe-status status-04 badge-preview">Watch Preview</span>
                                    </a>
                                </div> */}

                                    {isDiscountValid(data) && (
                                        <div className="wrap-resource text-center">
                                            <span className="ribbon-bottom fs-5 fw-bold text-center">
                                                {data?.discount?.discountPercent}% Off
                                            </span>
                                        </div>
                                    )}
                                </div>

                            </div>
                            <div className="d-flex align-items-start justify-content-between mt--20 mb--10">

                                <div className="edu-rating rating-default d-flex">
                                    <div className="rating eduvibe-course-rating-stars">
                                        <EbookStarRating reviews={review} />
                                    </div>
                                </div>
                                <div className="read-more-btn">
                                    <a
                                        className="btn-transparent-2 color-primary clickable"
                                        onClick={toggleTestimonialModal}
                                    >
                                        <i className="ri-eye-line p-0 me-2"></i> Add Review
                                    </a>
                                </div>
                            </div>

                        </div>

                        <div className="price-list price-style-03 text-center">
                            {!data?.pricing?.price || data?.pricing?.price <= 0 ? (
                                <div className="price fs-24 current-price-free">Free</div>
                            ) : (
                                <div className="price fs-24 current-price">
                                    {isDiscountValid(data)
                                        ? handleDiscountedPrice(data)?.formattedAmount
                                        : data?.pricing?.priceFormatted}
                                </div>
                            )}
                            {isDiscountValid(data) && (
                                <div className="price fs-24 old-price">
                                    {data.pricing?.priceFormatted}
                                </div>
                            )}
                        </div>

                        <div className="eduvibe-widget-details mt--20">
                            <div className="widget-content">
                                <ul>
                                    {data?.duration && (
                                        <li>
                                            <span>
                                                <i className="icon-time-line"></i> Duration
                                            </span>
                                            <span>{data?.duration}</span>
                                        </li>
                                    )}

                                    <li>
                                        <span>
                                            <i className="icon-draft-line"></i> Document Type
                                        </span>
                                        <span>PDF</span>
                                    </li>

                                    {data?.metadata?.pages && (
                                        <li>
                                            <span>
                                                <i className="icon-Open-book"></i> Pages
                                            </span>
                                            <span>{data?.metadata?.pages || 0}</span>
                                        </li>
                                    )}
                                    {data?.metadata?.downloads && (
                                        <li>
                                            <span>
                                                <i class="ri-download-line"></i> Downloads
                                            </span>
                                            <span>{data?.metadata?.downloads || 0}</span>
                                        </li>
                                    )}
                                    {data?.language && (
                                        <li>
                                            <span>
                                                <i className="icon-translate"></i> Language
                                            </span>
                                            <span>{data?.language}</span>
                                        </li>
                                    )}
                                </ul>

                                {activeStatus === PAID && (
                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                        <div className="read-more-btn mt--20 ebook-action-btn">
                                            <button className="edu-btn btn-medium btn-primary btn-border w-100 text-center"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setToggler((prev) => !prev);
                                                }}
                                            >
                                                Watch Preview
                                            </button>

                                        </div>
                                        <div className="read-more-btn mt--20 ebook-action-btn">
                                            <button
                                                className="edu-btn btn-medium w-100 text-center"
                                                onClick={() => handleDownloadBook(data)}
                                                disabled={isProcessingPayment}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {activeStatus === FREE && (

                                    <div className="read-more-btn mt--20">
                                        <button
                                            className="edu-btn btn-medium w-100 text-center"
                                            onClick={() => handleDownloadBook(data)}
                                            disabled={isProcessingPayment}
                                        >
                                            Download
                                        </button>
                                    </div>

                                )}

                                <div className="read-more-btn mt--30 text-center">
                                    <div className="eduvibe-post-share flex">
                                        <span className="mx-auto">Share : </span>
                                        <a
                                            className="linkedin mx-auto"
                                            href={""}
                                            onClick={handleLinkedInShare}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FaLinkedinIn />
                                        </a>

                                        <a
                                            className="Instagram mx-auto"
                                            href={""}
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={handleTwitterShare}
                                        >
                                            <FaTwitter />
                                        </a>
                                        <a
                                            className="youtube mx-auto"
                                            href={""}
                                            onClick={handleWhatsAppShare}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FaWhatsapp />
                                        </a>

                                        <a
                                            className="youtube clickable mx-auto"
                                            onClick={handleCopyLink}
                                        >
                                            <ToolTip title={isCopied ? "Copied" : "Click to Copy URL"}>
                                                <IoCopyOutline />
                                            </ToolTip>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalLogin
                        show={notLoggedIn}
                        onCloseModalLogin={closeModalLogin}
                        title={"Login to proceed action"}
                    />
                    {isPaymentDone() && (
                        <PaymentSuccessModel
                            show={isPaymentSuccess}
                            onCloseModal={closeModalPaymentSuccess}
                            response={newOrder}
                        />
                    )}


                    {showTestimonialModal && (
                        <TestimonialForm
                            show={showTestimonialModal}
                            data={data}
                            onCloseModal={toggleTestimonialModal}
                            title={"Submit Review"}
                        />
                    )}

                    <GenericPdfViewer data={{ url: filePath, title: previewName }} show={toggler} onCloseModal={togglePreviewModal} />
                </div>
            </div>
        </>
    );
};

export default EBookInfo;
